import { CheckoutAnalyticsService, RetailRocketService } from '@analytics/feature';
import { inject, Injectable } from '@angular/core';
import { CheckoutContactForm } from '@checkout-v2/const';
import { CheckoutActions, CheckoutActions as CustomCheckoutActions } from '@checkout-v2/data-access';
import { CityService } from '@city/feature';
import { Actions, createEffect, EffectNotification, ofType, OnRunEffects } from '@ngrx/effects';
import { CustomOrder } from '@order/const';
import { UserAccountFacade } from '@spartacus/user';
import { User } from '@user/const';
import { Observable, of } from 'rxjs';
import { exhaustMap, filter, map, takeUntil, withLatestFrom } from 'rxjs/operators';
import { CheckoutContactFormService } from '../services';

@Injectable()
export class CheckoutAnalyticsEffects implements OnRunEffects {
  private actions$ = inject(Actions);
  private retailRocketService = inject(RetailRocketService);
  private cityService = inject(CityService);
  private checkoutContactFormService = inject(CheckoutContactFormService);
  private userAccountService = inject(UserAccountFacade);
  private checkoutAnalyticsService = inject(CheckoutAnalyticsService);

  confirmOrder$: Observable<void> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CustomCheckoutActions.SET_ORDER_DETAILS),
        map(({ payload }) => payload),
        withLatestFrom(
          this.cityService.activeBaseStoreCode$,
          this.userAccountService.get().pipe(filter(Boolean)),
          of(this.checkoutContactFormService.getValue()),
        ),
        map(([order, activeBaseStoreCode, user, orderContacts]: [CustomOrder, string, User, CheckoutContactForm]) => {
          if (order.code) {
            this.checkoutAnalyticsService.onConfirmOrder(order);
            this.retailRocketService.onConfirmOrder({
              order,
              activeBaseStoreCode,
              orderEmail: orderContacts.email ?? '',
              user,
            });
          }
        }),
      ),
    { dispatch: false },
  );

  ngrxOnRunEffects(resolvedEffects$: Observable<EffectNotification>): Observable<EffectNotification> {
    return this.actions$.pipe(
      ofType(CheckoutActions.CHECKOUT_INIT),
      exhaustMap(() => resolvedEffects$.pipe(takeUntil(this.actions$.pipe(ofType(CheckoutActions.CHECKOUT_DESTROY))))),
    );
  }
}
